export const GIFT_PACKAGING_LOADER_SIZE = 31.25;
